/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MassTransitCommonSupportServiceMessageDataFromJSON, MassTransitCommonSupportServiceMessageDataToJSON, } from './MassTransitCommonSupportServiceMessageData';
/**
 * Check if a given object implements the FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand interface.
 */
export function instanceOfFxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand(value) {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('Data' in value) || value['Data'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommandFromJSON(json) {
    return FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommandFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'],
        'Data': MassTransitCommonSupportServiceMessageDataFromJSON(json['Data']),
    };
}
export function FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommandToJSON(json) {
    return FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommandToJSONTyped(json, false);
}
export function FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommandToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'Data': MassTransitCommonSupportServiceMessageDataToJSON(value['Data']),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand.js.map